import { Box } from '@mui/material'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import Image from 'next/image'
import styled from 'styled-components'

interface GetPromoDataResponse {
  ariaLabel: string
  logos: { src: string; width: string; height: string; alt: string }[]
}

const PRO_PLUS_LOGOS: GetPromoDataResponse = {
  ariaLabel:
    'Depended on by businesses like Keller Williams, Hilton Hotels & Resorts, The Home Depot, Chipotle Mexican Grill, and Allstate',
  logos: [
    {
      src: '/images/pages/upgrade/keller-williams-logo-on-white-2x.png',
      width: '52',
      height: '24',
      alt: 'Keller Williams'
    },
    {
      src: '/images/pages/upgrade/hilton-logo-on-white-2x.png',
      width: '48',
      height: '36',
      alt: 'Hilton Hotels & Resorts'
    },
    {
      src: '/images/pages/upgrade/home-depot-logo-on-white-2x.png',
      width: '36',
      height: '36',
      alt: 'The Home Depot'
    },
    {
      src: '/images/pages/upgrade/chipotle-logo-on-white-2x.png',
      width: '38',
      height: '38',
      alt: 'Chipotle Mexican Grill'
    },
    {
      src: '/images/pages/upgrade/allstate-logo-on-white-2x.png',
      width: '49',
      height: '10',
      alt: 'Allstate'
    }
  ]
}

const PRO_LOGOS: GetPromoDataResponse = {
  ariaLabel:
    'Depended on by businesses like Compass, Three Wishes, Hyatt, Massage Envy, and Orange Theory Fitness.',
  logos: [
    {
      src: '/images/pages/upgrade/compass-logo-on-white-2x.png',
      width: '40',
      height: '6',
      alt: 'Compass'
    },
    {
      src: '/images/pages/upgrade/three-wishes-logo-on-white-2x.png',
      width: '50',
      height: '27',
      alt: 'Three Wishes'
    },
    {
      src: '/images/pages/upgrade/hyatt-logo-on-white-2x.png',
      width: '50',
      height: '13',
      alt: 'Hyatt'
    },
    {
      src: '/images/pages/upgrade/massage-envy-logo-on-white-2x.png',
      width: '57',
      height: '12',
      alt: 'Massage Envy'
    },
    {
      src: '/images/pages/upgrade/orange-theory-fitness-logo-on-white-2x.png',
      width: '72',
      height: '19',
      alt: 'Orange Theory Fitness'
    }
  ]
}

function getLogoData(planType: PlanType): GetPromoDataResponse {
  if (planType === PlanType.PRO_PLUS_ORG) {
    return PRO_PLUS_LOGOS
  }
  return PRO_LOGOS
}

const _LeadingText = styled(Text)`
  text-align: center;
`

const _PartnerList = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  list-style-type: none;
  margin: 0;
  margin-top: 5px;
  padding: 0;
`

const _PartnerListItem = styled.li`
  display: block;
  margin: 0;
  padding: 0;
`

const _RootBox = styled(Box)`
  width: 100%;
`

interface PurchaseExperiencePartnersProps {
  planType: PlanType
}

export function PurchaseExperiencePartnerLogoList(
  props: PurchaseExperiencePartnersProps
): JSX.Element {
  const logoData = getLogoData(props.planType)
  return (
    <_RootBox aria-label={logoData.ariaLabel}>
      <_LeadingText component="p" variant="body/small" aria-hidden>
        Depended on by businesses like
      </_LeadingText>
      <_PartnerList>
        {logoData.logos?.map(({ width, height, src, alt }) => {
          return (
            <_PartnerListItem key={src}>
              <Image width={Number(width)} height={Number(height)} src={src} alt={alt} />
            </_PartnerListItem>
          )
        })}
      </_PartnerList>
    </_RootBox>
  )
}
